import React from "react";
import Base from "../base";
import EditDataform from "./EditDataForm";

import Swal from 'sweetalert2';

class EditMode extends React.Component {
  // Base ref
  ref = null;

  state = {
    users: {}
  };


  componentDidMount() {


    this.ref = Base.syncState("/users", {
      context: this,
      state: "users"
    });

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log('Updated', this.constructor.name)
  }

  componentWillUnmount() {
    Base.removeBinding(this.ref);
  }

  updateUser = (userData, form) => {
    const users = { ...this.state.users };
    const keys = Object.keys(users);
    let message = "";
    let isIdentical = false;

    for (const key of keys) {
      if (users[key].email !== userData.email) {
        message += "<p>Email has been updated</p>";
      }
      if (users[key].firstname !== userData.firstname) {
        message += "<p>First Name has been updated</p>";
      }
      if (users[key].lastname !== userData.lastname) {
        message += "<p>Last Name has been updated</p>";
      }
    }

    if (message.length === 0) {
      isIdentical = true;
      message = "Data is identical. No changes were made";
    }else{
        users["primary"] = userData;
        this.setState({ users });
    }


    Swal.fire({
      title: isIdentical ? 'Hey, nothing happened' : "Good Job!",
      html: message,
      type: isIdentical ? 'error' : "success",
    })


  };

  deleteProfile = () => {
    const users = { ...this.state.users };
    users["primary"] = null;
    this.setState({ users });



  }

  render() {
    return (
      <>
        <h1>Edit Data</h1>
        <p>Only one user is allowed, so you're always editing the same user.</p>

        <div className="fade-in">
        <EditDataform
          user={this.state.users[Object.keys(this.state.users)[0]]}
          updateUser={this.updateUser}
          deleteProfile={this.deleteProfile}
          history={this.props.history}
        />
        </div>
      </>
    );
  }
}

export default EditMode;
